const zhCN ={
    message:{
      "title":"养殖装备IOT物联网平台2.0",
      'home':'首页',
      'returnList':'返回列表',
      'return':'返回',
      'upload':'上传',
       "more":'更多',
      'loading':'加载中...',
      'placeholderTips':'请输入',
      "loadingCureve":'正在加载数据中...',
      "noCureveData":"无曲线数据",
      "realTabName1":"实时监控",
      "realTabName2":"基本信息",
      "realTabName3":"入料用料",
      "realTabName4":"参数设置",
      "realTabName5":"喂料记录",
      "language":"english",
      common:{
        "all":"全部",
        "online":"在线",
        "outline":"离线",
        "maintain":"待接入",
        "open":"开机",
        "stop":"停机",
        "put":"入料",
        "out":"出料",
        "days":"天",
        "notConnected":"未接入"
      },
      topMenu:{
        "index":"主页",
        "devices":"设备管理",
        "statistics":"统计查询",
        "enterprise":"企业管理",
        "afterSale":"产品售后",
        "system":"系统管理",
        "message":"消息管理",
        "setting":"设置",
        "logout":"退出",
        "hello":"您好",
        "cockpit":"进入驾驶舱",
        "profile":"个人信息",
        "profileTitle":"个人信息",
        "userName":"用户姓名",
        "loginAccount":"登录账号",
        "lastLoginDate":"上次登录日期"
      },
      leftMenu:{
        "title":"导航",
        "lm0":"物联网管理平台",
        "lm1":"设备可视化",
        "lm2":"养殖可视化", 
        "lm3":"设备管理", 
        "lm4":"迁移记录",
        "lm5":"入料统计",
        "lm6":"用料统计",
        "lm7":"操作记录",
        "lm8":"报警记录",
        "lm9":"连接记录",
        "lm10":"预警设置",
        "lm11":"养殖管理",
        "lm12":"喂养记录",
        "lm13":"喂料标准",
        "lm14":"设备分布",
        "lm15":"使用报表",
        "lm16":"储量统计图",
        "lm17":"充料报表",
        "lm18":"企业用户",
        "lm19":"企业管理",
        "lm20":"企业升级包",
        "lm21":"意见反馈",
        "lm22":"故障管理",
        "system":"系统管理",
        "lm23":"用户管理",
        "lm24":"部门管理",
        "lm25":"角色管理",
        "lm26":"数据字典",
        "lm27":"系统日志",
        "lm28":"产品管理",
        "lm29":"死亡记录",
        "lm30":"产品宣传",
        "lm31":"数据更新",
        "lm32":"设备监控",
        "lm33":"连接记录",
        "lm34":"统计查询",
        "lm35":"系统配置",
        "lm36":"离线统计",
        "lm37":"设备缴费提醒",
        "lm38":"logo设置",
        "lm39":"设备定位",
        "lm40":"接口管理",
        "lm41":"申诉管理",
        "lm42":"系统消息",
        "lm50":"帮助中心", // 帮助中心
        "lm51":"综合报表", // 综合报表
        "lm52":"财务中心", // 财务中心
        "lm53":"企业财务管理", // 余额账户管理
      },
      btn:{
        "group1":"控制设置",
        "group2":"工艺参数设置",
        "group3":"联网参数设置",
        "refresh": "刷新",
        "search":"搜索",
        "reset":"重置",
        "add":"添加",
        "edit":"编辑",
        "delete":"删除",
        "confirm": "确认",
        "save":"保存",
        "cancel":"取消",
        "close":"关闭",
        "submit":"提交",
        "resetPwd":"重置密码",
        "addBatch":"批量添加",
        "batchMigration":"批量迁移",
        "batchModify":"批量修改",
        "batchRestart":"批量重启",

        "batchHeart":"设置心跳",
        "batchAllow":"批量开机",
        "batchStop":"批量停机",


        "updateIot":"更新三元组",
        "batchImport":"导入",
        "batchExport":"导出",
        "allow_work": "允许工作",
        "stop_work": "停止工作",
        "restart_controller": "重启控制器",
        "clear_zero": "清零",
        "full_scale": "满量程",
        "division_value_calibration": "分度值标定",
        "weight_calibration": "砝码标定",
        "remote_address": "远程地址",
        "filter_coefficient": "滤波系数",
        "sensor_type_setting": "传感器类型设置",
        "status_threshold": "状态阈值",
        "zero_setting_1": "归零设置1",
        "zero_setting_2": "归零设置2",
        "sensitivity_and_decimal_setting": "感量和小数点设置",
        "creep_tracking_setting": "蠕变追踪设置",
        "weighing_speed_filter_mode": "称重速度/数字滤波方式",
        "filter_value_1": "滤波值1",
        "filter_value_2": "滤波值2",
        "heartbeat_interval": "心跳间隔",
        "local_calibration_password": "本地标定密码",
        "server_ip": "服务器IP",
        "server_ip_2": "服务器IP2",
        "stockAlertThreshold": "存量报警阈值"
      },
      //协议统计,产品统计,待处理售后,待处理,处理中,已完成，数据汇总，总监控，在线设备，企业，月新增设备，年新增设备，年新增企业，近一年在线趋势图，用户反馈
      index:{
        "title":"首页",
        "protocolStatistics":"协议统计",
        "productStatistics":"产品统计",
        "pendingAfterSale":"待处理售后",
        "faultStatistics":"故障统计",
        "faultStatisticsTitle":"故障统计 (总计: {total}次)",
        "faultCount":"故障数量",
        "noFaultData":"暂无故障数据",
        "noData":"暂无数据",
        "times":"次",
        "percentage":"占比",
        "pendingFaults":"待{count}条故障处理",
        "pending":"待处理",
        "processing":"处理中",
        "completed":"已完成",
        "dataSummary":"数据汇总",
        "allDevice":"总监控",
        "onlineDevice":"在线设备",
        "enterprise":"企业",
        "OnlineTrend":"近一年在线趋势",
        "yearGrowthTrend":"年增长趋势",
        "yearNewDevice":"年新增设备",
        "yearNewEnterprise":"年新增企业",
        "monthNewDevice":"月新增设备",
        "userFeedback":"用户反馈",
        "noPendingTasks":"暂无待处理任务"
      },
      index1:{
          "zjkssb": "总监控设备(台)",
          "zxsb": "在线设备(台)",
          "lxsb": "离线设备(条)",
          "jryj": "今日预警(t)",
          "jrsl": "今日上料(t)",
          "jryl": "今日用料",
          "cltj": "储量统计图",
          "gzdt": "工作动态",
          "prompt": "由于数量过大无法友好显示，请您选择企业进行查看！"
      },
      units:{
        "kg":"kg",
        "sets":"台",
        "Enterprises":"家",
        "ton":"吨"
      },
      real:{
        "title":"Real monitoring",
        "dataCurve":"数据曲线（更多）",
        "weightTitle":"仪表重量",
        "todayFeed":"今日上料",
        "todayUse":"今日用料",
        "stateMonitor":"状态监控",
        "dataMonitor":"数据监控",
        "basicInfo":"基本信息",
        "sensorMonitor":"传感器监控",
        "feedRecord":"喂料记录",
         //通讯时间，阀门电源，阀门，震动电机，水泵，搅拌电机
         "title1":"通讯时间",
         "title2":"阀门电源",
         "title3":"阀门",
         "title4":"震动电机",
         "title5":"水泵",
         "title6":"搅拌电机",
         //编号，内部编号，设备属性，容量
         "title7":"编号",
         "title8":"内部编号",
         "title9":"设备属性",
         "title10":"容量",
         "nmdjk": "内码数据监控",
         "xmtd": "项目/通道",
         "jnmd": "净内码",
         "nmdpc": "净码偏差",
         "zjzt": "支脚状态",
         "jnmdh": "净内码和",
         "jnmdjz": "净内码均值",
         "ztsl": "支腿数量",
         "pcbj": "偏差报警",
         "domode": "DO模式",
         "cgqzt": "传感器状态",
         "zxqc": "在线且正常",
         "lx": "离线",
         "zx": "在线",
         "wjr": "未接入",
         "mfzt": "阀门状态",
         "xlz": "下料中",
         "slz": "上料中",
         "jp": "静置",
         "high": "偏高",
         "low": "偏低",
         "normal": "正常",
          "weight": "重量",
          "adValue": "AD值"
      },
      tooltip:{
        "hideQuery":"隐藏查询条件",
        "refresh":"刷新",
      },
      deviceAlarm:{
        "ytjTitle":"添加一体机预警",
        "ruleName":"规则名称",
        "ruleNamePlaceholder":"请输入规则名称",
        "alarmInterval":"报警静默时间",
        "intervalUnit":"单位：分钟",
        "tel":"接收手机号",
        "telPlaceholder":"11位手机号",
        "protocolType":"协议类型",
        "protocolPlaceholder":"请选择协议类型",
        "company":"选择企业",
        "companyPlaceholder":"请选择企业",
        "isSend":"发送短信",
        "isVoice":"语音通知",
        "isEnable":"报警开关",
        "astTitle":"复杂条件（树形AST编辑）",
        "astTips":"先选择协议类型，字段会自动加载；然后可编辑 AND/OR 与条件叶子节点。",
        "tipRuleName":"请输入规则名称",
        "tipSelectProtocol":"请选择协议类型",
        "tipSelectCompany":"请选择企业",
        "tipTel":"请输入接收手机号",
        "saveFail":"保存失败",
        "noConfigId":"未获取到配置ID",
        "saveTreeFail":"条件树保存失败",
        "saveSuccess":"保存成功",
        "group":"分组",
        "leaf":"条件",
        "and":"且(AND)",
        "or":"或(OR)",
        "addGroup":"添加分组",
        "addLeaf":"添加条件",
        "delete":"删除",
        "selectField":"选择字段",
        "operator":"操作符",
        "compareValue":"比较值",
        "voiceNotification":"语音通知",
        "sendSms":"发送短信",
        "selectNotification":"请选择通知方式"
      },
      //序号，编号，企业编号，设备属性，属性 ，容量，余量，仓满率，SIM卡，标定状态，状态，产品，型号，版本，操作
      deviceList:{
        "title":'设备列表',
        "title1":"序号",
        "title2":"编号",
        "title3":"企业编号",
        "title4":"设备属性",
        "title5":"属性",
        "title6":"容量(t)",
        "title7":"余量",
        "title8":"仓满率",
        "title9":"SIM卡",
        "title10":"标定状态",
        "title11":"状态",
        "title12":"产品",
        "title13":"型号",
        "title14":"版本",
        "title15":"操作",
        "cond1":"企业",
        "cond2":"产品",
        "cond3":"关键字",
        "cond4":"重量",
        "cond5":"版本",
        "cond6":"状态",
        "cond7":"协议",
        "cond8":"排序",
        "view": "监控",  
        //提示框
        "pl1":"全部企业",
        "pl2":"全部产品",
        "pl3":"编号、设备属性、SIM",
        "pl4":"重量1",
        "pl5":"重量2",
        "pl6":"版本",
        "pl7":"全部",
        "pl8":"全部协议",
        //label
        "online":"在线",
        "outline":"离线",
        "all":"全部",
        "unit1":"台",
        "hideSearchConditions": "隐藏查询条件",
        "refresh": "刷新",
        "cardMode": "卡片模式",
        "listMode": "列表模式", 
        "temperature": "目标温度", 
        "avgTemperature": "平均温度", 
        "humidity": "湿度",
        "stock": "存栏", 
        "age": "日龄" ,
        "flowAccumulated": "流量累计",
        "topSpray": "顶部喷淋",
        "sideSpray": "侧面喷淋",
        "wastewaterPumpSpray": "排污泵喷淋",
        "walkCount": "行走次数",
        "leftCarPosition": "左车位置",
        "rightCarPosition": "右车位置",
        //刮粪机
        "position1": "1#当前位置",
        "speed1": "1#行走速度",
        "operations1": "1#运行次数",
        "position2": "2#当前位置",
        "speed2": "2#行走速度",
        "operations2": "2#运行次数"


      },
      deviceCard:{
        "product":"产品",
        "attr":"属性",
        "target":"目标",
        "dStatus":"标定状态",
        "capacity":"容量",
        "states":"状态",
        "still":"静置",
        "adding":"上料中",
        "using":"用料中",
      },
      breedRecord:{
          "breedState":"养殖状态",
          "networkState":"联网状态",
          "zrls":"总入栏数",
          "dqls":"当前栏数",
          "jcsl":"均采食量",
          "jrrl":"今日入料",
          "ljrl":"累计入料",
          "jzgz":"均重估值",
          "jryl":"今日用料",
          "ljyl":"累计用料",
          "lrb":"料肉比",
          "zl":"重量",
          "cml":"仓满率",
          "ydy":"已饲养",
          "ywc":"已完成",
          "byz":"备养中"
      },
      deviceInfor:{
        "jbxx": "基本信息",
        "sbcs": "设备参数",
        "bdxx": "标定信息",
        "qtxx": "其他信息",
        "qy": "企业",
        "bh": "编号",
        "qynbbh": "企业内部编号",
        "sbzs": "设备属性",
        "sx": "属性",
        "fzr": "负责人",
        "sim": "SIM",
        "sbscqy": "设备生产企业",
        "kzqscqy": "控制器生成企业",
        "ybmx": "仪表型号",
        "cpfl": "产品分类",
        "xy": "协议",
        "xtlb": "系统类别",
        "rl": "容量",
        "cg": "仓高(m)" ,
        "kwrl": "空仓容量",
        "nbfdz": "内部分度值",
        "kgadz": "空罐AD值",
        "eddl": "额度电流",
        "djgl": "电机功率",
        "sbxh": "设备型号",
        "bjsx": "报警限制",
        "cgxlx": "传感器类型",
        "dw": "单位",
        "scbs": "上传倍数",
        "xsd": "小数点",
        "ybbb": "仪表版本",
        "mzbb": "模组版本",
        "plcbb": "PLC版本",
        "bdzt": "标定状态",
        "cjsh": "创建时间",
        "cjr": "创建人",
        "bz": "备注",
        "bz2": "备注(管理)",
        "ly": "来源",
        "sensorCount": "传感器显示数量",
        "statInfeed": "统计入料",
        "enable": "开启",
        "disable": "关闭"
      },
      settingPage:{
        "xh": "序号",
        "czr": "操作人",
        "cznr": "操作内容",
        "czsj": "操作时间"
      },
      realRlyl:{
          "j2yslfx": "近期用料上料分析图",
          "ylkg": "用料(kg)",
          "rlkg": "入料(kg)",
          "rlxx": "入料信息",
          "ylxx": "用料信息",
          "xh": "序号",
          "sj": "时间",
          "zl": "重量",
          "sfqr": "是否确认",
          "ck": "查看",
          "jrr": "今日",
          "wqr": "未确认",
          "yqr": "已确认"
      },
      loginPage:{
          "title": "养殖装备物联网管理平台",  
          "subtitle": "智能化 · 自动化 · 数字化养殖管理",
          "welcome": "欢迎登录",
          "loginSubtitle": "进入智慧养殖管理平台",
          "username": "账号",  
          "password": "密码", 
          "oldSystem": "旧系统登录",
          "login": "登录",
          "enterUsername": "请输入账号",  
          "enterPassword": "请输入密码",
          "feature1": "智能自动化",
          "feature2": "AI数据分析",
          "feature3": "实时监控",
          "feature4": "精准管理",
          "mobileAccess": "移动端访问",
          "scanToLogin": "扫码登录",
          "wechatQr": "微信二维码",
          "miniprogramQr": "小程序二维码",
          "copyright": "版权所有",
          "icp": "豫ICP备12002457号-9"
      },
      setting:{
        "systemSettings": "系统设置",
        "settings": "设置",
        "defaultProduct": "默认产品",
        "securitySettings": "安全设置",
        "oldPassword": "旧密码",
        "newPassword": "新密码",
        "confirmNewPassword": "确认新密码",
        "enterNewPassword": "请输入新密码",
        "reEnterNewPassword": "请再次输入新密码",
        "passwordsDoNotMatch": "两次密码不匹配",
        "enterOldPassword": "请输入旧密码",
        "paramsOutError": "出料误差阈值",
        "paramsInError": "进料误差阈值",
        "paramsCalcError": "计算容差范围",
        "paramsSetting": "出入料参数设置",
        "paramsSaveSuccess": "参数保存成功",
        "errorMessage": "错误信息",
        "companyInfo": "企业信息",
        "companyName": "企业名称",
        "companyAddress": "企业地址",
        "companyPhoto": "企业照片",
        "selectFile": "选取附件",
        "enterParamsOutError": "请输入出料误差阈值",
        "enterParamsInError": "请输入进料误差阈值",
        "enterParamsCalcError": "请输入计算容差范围",
        "unit": "单位",
        "unitKg": "kg",
        "paramsOutDescription": "当系统计算出料重量小于此值时，将不记录为有效出料操作。建议范围：50-200kg，可根据设备精度调整。",
        "paramsInDescription": "当系统计算出进料重量小于此值时，将不记录为有效进料操作。建议范围：50-200kg，避免误触发进料记录。",
        "paramsCalcErrorDescription": "系统计算过程中，重量变化小于此值时视为正常波动。影响因素：风力、温度变化、设备振动等环境因素。"
    },
    msg:{
        "errorMessage": "错误信息",
        "saveSuccess": "保存成功",
        "deleteSuccess": "删除成功",
        "updateSuccess": "修改成功",   
    },
    curve:{
      "dataTrend": "数据趋势",
      "type": "类型",
      "selectType": "请选择类型",
      "last1Day": "近1天",
      "last2Days": "近2天",
      "last3Days": "近3天",
      "last30Days": "近1月",
      "last60Days": "近2月",
      "last90Days": "近3月",
      "last180Days": "近半年",
      "custom": "自定义",
      "date": "日期",
      "startDate": "开始日期",
      "endDate": "结束日期",
      "exportData": "导出数据",
      "dataCurve": "数据曲线"
    },
    "status": {
      "notSet": "未设置",
      "unCalibrated": "未标定",
      "roughCalibration": "粗略标定",
      "calibrationComplete": "标定完成",
      "preciseCalibration": "精确标定",
      "sensorFault": "传感器故障"
    },
    "channels": {
        "ch1": "1通道",
        "ch2": "2通道",
        "ch3": "3通道",
        "ch4": "4通道",
        "ch5": "5通道",
        "ch6": "6通道",
        "ch7": "7通道",
        "ch8": "8通道",
        "ch9": "9通道",
        "ch10": "10通道",
        "ch11": "11通道",
        "ch12": "12通道",
        "ch13": "13通道",
        "ch14": "14通道",
        "ch15": "15通道",
        "ch16": "16通道",
        "ch17": "17通道",
        "ch18": "18通道",
        "ch19": "19通道",
        "ch20": "20通道",
        "ch21": "21通道",
        "ch22": "22通道",
        "ch23": "23通道",
        "ch24": "24通道",
        "ch25": "25通道",
        "ch26": "26通道",
        "ch27": "27通道",
        "ch28": "28通道",
        "ch29": "29通道",
        "ch30": "30通道",
        "ch31": "31通道",
        "ch32": "32通道"
    }
    }
  }
  export default zhCN